import { type Ref, useEffectEvent, useLayoutEffect } from "react";
import { eventNames, shopWindowTypes } from "@/modules/Constants";
import ShopWindowHeader from "@/components/shopwindow/ShopWindowHeader";
import type ShopWindowConfig from "@/plugin/ShopWindowConfig";
import type { ExperienceState } from "@/types/state";

const REGION = "Test Shop Window";

type TestShopWindowProps = {
  experienceState: ExperienceState;
  config: ShopWindowConfig;
  hasHeader?: boolean;
  hasExitButton?: boolean;
  nodeRef?: Ref<HTMLDivElement>;
  onApplicationEvent: (event: Record<string, unknown>) => void;
};

// A mock tab for trying feature flags: RecipePlugin adds it only while
// demo.test_tab is on.
export default function TestShopWindow({
  experienceState,
  config,
  hasHeader,
  hasExitButton,
  nodeRef,
  onApplicationEvent,
}: TestShopWindowProps) {
  const onDidMount = useEffectEvent(() => {
    onApplicationEvent({
      region: REGION,
      name: eventNames.SHOP_WINDOW_DID_MOUNT,
      type: shopWindowTypes.TEST,
    });
  });
  // componentDidMount: layout phase, after the children's mount effects.
  useLayoutEffect(() => {
    onDidMount();
  }, []);

  const onExit = () => {
    onApplicationEvent({
      name: eventNames.SHOP_WINDOW_EXIT,
      region: REGION,
      shopWindowConfig: config,
    });
  };

  const experienceData = experienceState.experienceData;
  const header = hasHeader ? (
    <ShopWindowHeader
      src={experienceData.getLogoImageUrl()}
      hasExitButton={hasExitButton}
      onExit={onExit}
    />
  ) : null;

  return (
    <div
      className="list-shop-window tw:absolute tw:inset-0 tw:flex tw:flex-col tw:items-stretch tw:bg-[#fff]"
      ref={nodeRef}
    >
      {header}
      <div className="test-shop-window content tw:px-[20px] tw:py-[16px]">
        <h2 className="header-1">Test</h2>
        <p>
          This is mock text on the Test tab. Switch demo.test_tab off and this
          tab disappears.
        </p>
      </div>
    </div>
  );
}
